(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["teko-product-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (window.TekoWelcomePopup) return;
  let settings = { formId: 'VsbrVJ', customTriggerConfirmed: false };
  let finderActive = document.documentElement.dataset.tekoFinderActive === 'true';
  function reason(eligible) {
    if (location.pathname.includes('first-quiz-cleaning-helper')) return 'dedicated_page';
    if (finderActive || document.documentElement.dataset.tekoFinderActive === 'true') return 'finder_active';
    if (document.querySelector('teko-product-quiz[data-finder-active="true"]')) return 'finder_active';
    if (!settings.customTriggerConfirmed) return 'custom_trigger_not_confirmed';
    if (eligible !== true) return 'eligibility_not_confirmed';
    if (typeof window._klOnsite?.openForm !== 'function' || typeof window._klOnsite?.push !== 'function') return 'sdk_not_ready';
    return null;
  }
  function publish() {
    document.documentElement.dataset.tekoWelcomeGate = location.pathname.includes('first-quiz-cleaning-helper') ? 'dedicated_page' : finderActive ? 'finder_active' : settings.customTriggerConfirmed ? 'ready' : 'awaiting_configuration';
  }
  function configure(options) {
    if (options?.formId !== 'VsbrVJ') return false;
    settings = { formId: options.formId, customTriggerConfirmed: options.customTriggerConfirmed === true };
    publish(); return true;
  }
  function requestOpen(options = {}) {
    const blocked = reason(options.eligible);
    if (blocked) return { opened: false, reason: blocked };
    const command = ['openForm', settings.formId];
    if (typeof options.onOpen === 'function') command.push(options.onOpen);
    window._klOnsite.push(command);
    return { opened: true, reason: null };
  }
  document.addEventListener('teko:finder:activity', event => { finderActive = event.detail?.active === true; publish(); });
  window.TekoWelcomePopup = { configure, requestOpen, status: () => ({ ...settings, finderActive, excludedPage: location.pathname.includes('first-quiz-cleaning-helper') }) };
  publish();
})();
(() => {
  'use strict';
  if (window.TekoFinderSignup) return;
  const pendingIdentities = new Set();
  const acceptedAttempts = new Map();
  const activeFinders = new Set();
  const node = (tag, cls, text) => {
    const element = document.createElement(tag);
    if (cls) element.className = cls;
    if (text !== undefined) element.textContent = text;
    return element;
  };
  function activity(host, active) {
    if (active) activeFinders.add(host); else activeFinders.delete(host);
    host.dataset.finderActive = String(active);
    document.documentElement.dataset.tekoFinderActive = String(activeFinders.size > 0);
    document.dispatchEvent(new CustomEvent('teko:finder:activity', { detail: { active: activeFinders.size > 0, entryPoint: host.signupOptions?.entryPoint || 'dedicated_page' } }));
  }
  function disclosure(html) {
    const fragment = document.createDocumentFragment();
    const documentCopy = new DOMParser().parseFromString(html || '', 'text/html');
    const copy = (source, target) => {
      for (const child of source.childNodes) {
        if (child.nodeType === Node.TEXT_NODE) target.append(document.createTextNode(child.textContent));
        else if (child.nodeType === Node.ELEMENT_NODE && ['P', 'A', 'BR', 'STRONG', 'EM'].includes(child.tagName)) {
          const element = document.createElement(child.tagName.toLowerCase());
          if (child.tagName === 'A') {
            try {
              const url = new URL(child.getAttribute('href'), location.origin);
              if (url.protocol === 'https:') { element.href = url.href; element.target = '_blank'; element.rel = 'noopener noreferrer'; }
            } catch (_) {}
          }
          copy(child, element);
          target.append(element);
        }
      }
    };
    copy(documentCopy.body, fragment);
    return fragment;
  }
  function normalizePhone(value) {
    let phone = value.trim().replace(/[\s().-]/g, '');
    if (/^\d{10}$/.test(phone)) phone = '+1' + phone;
    if (/^1\d{10}$/.test(phone)) phone = '+' + phone;
    return /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(phone) ? phone : null;
  }
  function buildPayload(quiz, fields, options) {
    const snapshot = JSON.parse(JSON.stringify(quiz.snapshot()));
    if (!snapshot.result_id || !snapshot.proposed_profile_properties.teko_helper_completed_at) throw Error('incomplete');
    const channels = fields.channels === 'both' ? ['email', 'sms'] : fields.channels === 'sms' ? ['sms'] : ['email'];
    const attributes = { subscriptions: {} };
    if (channels.includes('email')) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.trim())) throw Error('email');
      if (!fields.emailConsent) throw Error('emailConsent');
      attributes.email = fields.email.trim();
      attributes.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
    }
    if (channels.includes('sms')) {
      if (!options.smsDisclosure || !options.smsCountries?.length || !options.privacyUrl || !options.smsTermsUrl) throw Error('smsUnavailable');
      const phone = normalizePhone(fields.phone);
      if (!phone) throw Error('phone');
      if (!fields.smsConsent) throw Error('smsConsent');
      attributes.phone_number = phone;
      attributes.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
    }
    const allowed = new Set(quiz.config.questions.map(question => question.profile_property).filter(key => !key.startsWith('teko_welcome_')));
    ['teko_latest_quiz_id', 'teko_latest_quiz_version', 'teko_helper_result', 'teko_helper_completed_at'].forEach(key => allowed.add(key));
    attributes.properties = Object.fromEntries(Object.entries(snapshot.proposed_profile_properties).filter(([key, value]) => allowed.has(key) && value !== null && value !== undefined));
    Object.assign(attributes.properties, {
      teko_helper_quiz_version: quiz.config.quiz_version,
      teko_helper_submission_id: snapshot.submission_id,
      teko_latest_survey_origin: 'everyday_helper',
      teko_finder_entry_point: options.entryPoint === 'homepage' ? 'homepage' : 'dedicated_page',
      teko_finder_signup_version: 'v1_25_either_channel',
      teko_finder_requested_channels: channels
    });
    return { data: { type: 'subscription', attributes: { custom_source: 'TEKO Product Finder', profile: { data: { type: 'profile', attributes } } }, relationships: { list: { data: { type: 'list', id: options.listId } } } } };
  }
  class Signup {
    constructor(quiz, mount) {
      this.quiz = quiz;
      this.host = quiz.host;
      this.mount = mount;
      this.options = this.host.signupOptions || {};
      this.ui = quiz.config.ui;
      this.state = quiz.signupState;
      if (acceptedAttempts.has(quiz.attemptId)) { this.state.accepted = true; this.state.channels = acceptedAttempts.get(quiz.attemptId); }
      this.controller = new AbortController();
      this.disposed = false;
      if (!this.options.show) return;
      this.render();
    }
    listen(element, event, handler) { element.addEventListener(event, handler, { signal: this.controller.signal }); }
    capture() {
      if (!this.form || this.state.accepted || this.state.pending) return;
      const selected = this.form.querySelector('input[type="radio"]:checked');
      if (selected) this.state.channels = selected.value;
      this.state.email = this.email.value;
      this.state.phone = this.phone.value;
      this.state.emailConsent = this.emailConsent.checked;
      this.state.smsConsent = this.smsConsent.checked;
    }
    destroy() { this.capture(); this.disposed = true; this.controller.abort(); }
    render() {
      const ui = this.ui, prefix = this.host.id + '-finder';
      const card = node('section', 'tq-signup-card');
      card.setAttribute('aria-labelledby', prefix + '-title');
      const heading = node('h3', '', ui.signup_title); heading.id = prefix + '-title';
      card.append(heading, node('p', 'tq-signup-detail', ui.signup_detail), node('p', 'tq-offer-terms', ui.offer_terms));
      const form = node('form', 'tq-signup-form'); form.noValidate = true; form.method = 'post';
      this.form = form;
      const choices = node('fieldset', 'tq-signup-channels');
      choices.append(node('legend', '', ui.signup_channel));
      const row = node('div', 'tq-channel-options');
      for (const [value, label] of [['email', ui.channel_email], ['sms', ui.channel_sms], ['both', ui.channel_both]]) {
        const wrap = node('label', 'tq-channel');
        const input = node('input'); input.type = 'radio'; input.name = prefix + '-channels'; input.value = value; input.checked = this.state.channels === value;
        wrap.append(input, node('span', '', label)); row.append(wrap);
        this.listen(input, 'change', () => { this.capture(); this.state.error = ''; this.update(); });
      }
      choices.append(row); form.append(choices);
      const field = (label, type, key, autocomplete) => {
        const wrap = node('div', 'tq-signup-field');
        const caption = node('label', '', label); caption.htmlFor = prefix + '-' + key;
        const input = node('input'); input.type = type; input.id = prefix + '-' + key; input.name = prefix + '-' + key; input.autocomplete = autocomplete; input.value = this.state[key];
        if (type === 'tel') { input.inputMode = 'tel'; input.placeholder = '+1'; }
        this.listen(input, 'input', () => { this.capture(); this.state.error = ''; this.status.textContent = ''; });
        wrap.append(caption, input); return { wrap, input };
      };
      const email = field(ui.email_label, 'email', 'email', 'email'); this.email = email.input;
      const phone = field(ui.phone_label, 'tel', 'phone', 'tel'); this.phone = phone.input;
      const consent = (text, key) => {
        const wrap = node('label', 'tq-consent'); const input = node('input'); input.type = 'checkbox'; input.name = prefix + '-' + key; input.checked = this.state[key];
        wrap.append(input, node('span', '', text)); this.listen(input, 'change', () => { this.capture(); this.state.error = ''; this.update(); }); return { wrap, input };
      };
      const emailConsent = consent(ui.email_consent, 'emailConsent'); this.emailConsent = emailConsent.input;
      const smsConsent = consent(ui.sms_consent, 'smsConsent'); this.smsConsent = smsConsent.input;
      this.emailGroup = node('div'); this.emailGroup.append(email.wrap, emailConsent.wrap);
      const privacy = node('a', 'tq-policy-link', ui.privacy_link); privacy.href = this.options.privacyUrl || '#'; privacy.target = '_blank'; privacy.rel = 'noopener noreferrer';
      this.emailGroup.append(privacy);
      this.phoneGroup = node('div');
      const smsCopy = node('div', 'tq-sms-disclosure'); smsCopy.append(disclosure(this.options.smsDisclosure));
      this.phoneGroup.append(phone.wrap, node('p', 'tq-signup-detail', ui.sms_countries), smsCopy, smsConsent.wrap);
      form.append(this.emailGroup, this.phoneGroup);
      this.submitButton = node('button', 'tq-primary', ui.signup_submit); this.submitButton.type = 'submit';
      this.status = node('p', 'tq-signup-status'); this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite'); this.status.tabIndex = -1;
      this.status.id = prefix + '-status'; this.email.setAttribute('aria-describedby', this.status.id); this.phone.setAttribute('aria-describedby', this.status.id);
      form.append(this.submitButton); card.append(form, this.status);
      const shop = node('a', 'tq-continue', ui.continue_shopping); shop.href = this.quiz.config.products[this.quiz.nodes.get(this.quiz.id).product_key].url;
      this.listen(shop, 'click', () => activity(this.host, false)); card.append(shop);
      this.listen(form, 'submit', event => { event.preventDefault(); this.submit(); });
      this.mount.replaceChildren(card); this.update();
    }
    update() {
      if (this.disposed) return;
      const state = this.state, ui = this.ui;
      const emailSelected = state.channels !== 'sms', smsSelected = state.channels !== 'email';
      this.emailGroup.hidden = !emailSelected; this.phoneGroup.hidden = !smsSelected;
      this.email.required = emailSelected; this.emailConsent.required = emailSelected;
      this.phone.required = smsSelected; this.smsConsent.required = smsSelected;
      this.form.hidden = state.accepted || acceptedAttempts.has(this.quiz.attemptId);
      for (const input of this.form.querySelectorAll('input')) input.disabled = state.pending;
      this.submitButton.disabled = state.pending || !this.options.enabled;
      this.submitButton.textContent = state.pending ? ui.signup_pending : ui.signup_submit;
      for (const button of this.host.querySelectorAll('.tq-text-button')) button.disabled = state.pending;
      this.status.setAttribute('role', state.error ? 'alert' : 'status');
      this.status.textContent = state.error || (state.accepted ? ui['signup_accepted_' + state.channels] : state.pending ? ui.signup_pending : !this.options.enabled ? ui.signup_unavailable : '');
    }
    async submit() {
      if (!this.options.enabled || this.state.pending || this.state.accepted || acceptedAttempts.has(this.quiz.attemptId)) return;
      this.capture();
      const state = this.state;
      let payload;
      try { payload = buildPayload(this.quiz, state, this.options); }
      catch (error) {
        state.error = this.ui['signup_error_' + error.message] || this.ui.signup_error_generic; this.update();
        const input = error.message.startsWith('email') ? error.message === 'email' ? this.email : this.emailConsent : error.message.startsWith('sms') ? this.smsConsent : this.phone;
        input.focus(); return;
      }
      const attributes = payload.data.attributes.profile.data.attributes;
      const identities = [attributes.email ? 'email:' + attributes.email.toLowerCase() : null, attributes.phone_number ? 'sms:' + attributes.phone_number : null].filter(Boolean);
      if (identities.some(id => pendingIdentities.has(id))) { state.error = this.ui.signup_error_duplicate; this.update(); return; }
      identities.forEach(id => pendingIdentities.add(id));
      state.pending = true; state.error = ''; this.update();
      const abort = new AbortController(); const timeout = setTimeout(() => abort.abort(), 15000);
      const attempt = this.quiz.attemptId;
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.options.siteId), {
          method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', signal: abort.signal,
          headers: { accept: 'application/vnd.api+json', 'content-type': 'application/vnd.api+json', revision: '2026-07-15' }, body: JSON.stringify(payload)
        });
        if (response.status !== 202) { const error = Error('request'); error.status = response.status; throw error; }
        acceptedAttempts.set(attempt, state.channels); state.accepted = true; state.email = ''; state.phone = ''; state.emailConsent = false; state.smsConsent = false;
        if (!this.disposed) { this.email.value = ''; this.phone.value = ''; }
        this.quiz.clearProgress();
      } catch (error) { state.error = error.status === 429 ? this.ui.signup_error_rate : this.ui.signup_error_generic; }
      finally {
        clearTimeout(timeout); identities.forEach(id => pendingIdentities.delete(id)); state.pending = false;
        if (!this.disposed && this.quiz.attemptId === attempt) this.update();
      }
    }
  }
  window.TekoFinderSignup = { Signup, buildPayload, activity };
})();
(() => {
  'use strict';
  function validate(config) {
    if (!config || !Array.isArray(config.questions) || !Array.isArray(config.results)) throw Error('Questions and results are required.');
    if (config.mode !== 'browse') throw Error('Unsupported quiz mode.');
    const nodes = new Map();
    const add = (node, type) => {
      if (!node.id || nodes.has(node.id)) throw Error('Missing or duplicate node ID.');
      nodes.set(node.id, { ...node, nodeType: type });
    };
    config.questions.forEach(q => add(q, 'question'));
    config.results.forEach(r => add(r, 'result'));
    for (const q of config.questions) {
      if (q.type !== 'single_choice' || q.value_type !== 'string') throw Error('Unsupported question type.');
      if (!/^teko_[a-z0-9_]+$/.test(q.profile_property)) throw Error('Invalid profile property.');
      if (!q.prompt || !Array.isArray(q.choices) || !q.choices.length) throw Error('A question needs choices.');
      const values = new Set();
      for (const a of q.choices) {
        if (typeof a.value !== 'string' || !a.value || values.has(a.value) || !a.label) throw Error('Invalid or duplicate answer value.');
        values.add(a.value);
        if (!nodes.has(a.next)) throw Error('Missing destination: ' + a.next);
      }
    }
    for (const r of config.results) {
      if (!r.product_key || !config.products?.[r.product_key]) throw Error('Missing product.');
      if (r.content_ready !== true && !nodes.has(r.fallback)) throw Error('Missing fallback.');
    }
    for (const p of Object.values(config.products || {})) {
      const url = new URL(p.url, 'https://tekoclean.com');
      if (url.protocol !== 'https:' || !p.title) throw Error('Invalid product link.');
    }
    const visited = new Set();
    function walk(id, stack) {
      if (stack.has(id)) throw Error('Circular route.');
      const n = nodes.get(id);
      if (!n) throw Error('Missing start question.');
      visited.add(id);
      const nextStack = new Set(stack).add(id);
      if (n.nodeType === 'question') n.choices.forEach(a => walk(a.next, nextStack));
      else if (n.content_ready !== true) walk(n.fallback, nextStack);
    }
    walk(config.start_question, new Set());
    if (visited.size !== nodes.size) throw Error('Unreachable quiz content.');
    return nodes;
  }
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  };
  class Quiz {
    constructor(root, config, host) {
      this.root = root;
      this.host = host;
      this.config = config;
      this.nodes = validate(config);
      this.history = [];
      this.id = config.start_question;
      this.completedAt = null;
      this.attemptId = crypto.randomUUID();
      this.signupState = this.emptySignup();
      this.progressKey = 'teko:finder:' + config.quiz_id + ':' + config.quiz_version;
      this.restoreProgress();
      this.draw(false);
    }
    emptySignup() { return { channels: 'email', email: '', phone: '', emailConsent: false, smsConsent: false, pending: false, accepted: false, error: '' }; }
    clearProgress() { try { sessionStorage.removeItem(this.progressKey); } catch (_) {} }
    saveProgress() {
      if (!this.host.signupOptions?.remember) return;
      try { sessionStorage.setItem(this.progressKey, JSON.stringify({ history: this.history, attemptId: this.attemptId, completedAt: this.completedAt, savedAt: Date.now() })); } catch (_) {}
    }
    restoreProgress() {
      if (!this.host.signupOptions?.remember || Array.from(document.querySelectorAll('teko-product-quiz')).some(host => host !== this.host && host.quiz?.config.quiz_id === this.config.quiz_id)) return;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.progressKey));
        if (!saved || !Number.isFinite(saved.savedAt) || saved.savedAt > Date.now() || Date.now() - saved.savedAt > 1800000 || !Array.isArray(saved.history) || saved.history.length > this.config.questions.length || !/^[0-9a-f-]{36}$/i.test(saved.attemptId)) return;
        let id = this.config.start_question;
        const history = [];
        for (const entry of saved.history) {
          const question = this.nodes.get(id);
          const answer = question?.choices?.find(choice => choice.value === entry.value);
          if (entry.id !== id || !answer) return;
          history.push({ id, value: answer.value }); id = answer.next;
        }
        this.history = history; this.id = id; this.attemptId = saved.attemptId;
        this.completedAt = this.nodes.get(id).nodeType === 'result' ? (typeof saved.completedAt === 'string' && Number.isFinite(Date.parse(saved.completedAt)) ? saved.completedAt : new Date().toISOString()) : null;
        if (history.length) window.TekoFinderSignup?.activity(this.host, true);
      } catch (_) {}
    }
    snapshot() {
      const props = {};
      const answers = {};
      for (const entry of this.history) {
        const q = this.nodes.get(entry.id);
        const a = q.choices.find(c => c.value === entry.value);
        props[q.profile_property] = a.value;
        answers[q.id] = a.value;
      }
      const current = this.nodes.get(this.id);
      if (current.nodeType === 'result') Object.assign(props, {
        teko_latest_quiz_id: this.config.quiz_id,
        teko_latest_quiz_version: this.config.quiz_version,
        teko_helper_result: current.id,
        teko_helper_completed_at: this.completedAt
      });
      return { mode: 'browse', sent: false, quiz_id: this.config.quiz_id, result_id: current.nodeType === 'result' ? current.id : null, answers, proposed_profile_properties: props, submission_id: this.attemptId };
    }
    choose(value) {
      if (this.signupState.pending) return;
      const q = this.nodes.get(this.id);
      if (q.nodeType !== 'question') return;
      const answer = q.choices.find(a => a.value === value);
      if (!answer) return;
      this.history.push({ id: q.id, value });
      this.id = answer.next;
      let target = this.nodes.get(this.id);
      while (target.nodeType === 'result' && target.content_ready !== true) {
        this.id = target.fallback;
        target = this.nodes.get(this.id);
      }
      if (target.nodeType === 'result') this.completedAt = new Date().toISOString();
      this.saveProgress();
      window.TekoFinderSignup?.activity(this.host, true);
      this.draw(true);
    }
    back() {
      if (this.signupState.pending) return;
      const prior = this.history.pop();
      if (!prior) return;
      this.id = prior.id;
      this.completedAt = null;
      this.saveProgress();
      this.draw(true);
    }
    restart() {
      if (this.signupState.pending) return;
      this.history = [];
      this.id = this.config.start_question;
      this.completedAt = null;
      this.attemptId = crypto.randomUUID();
      this.signupState = this.emptySignup();
      this.clearProgress();
      this.draw(true);
    }
    button(label, cls, action) {
      const b = el('button', cls, label);
      b.type = 'button';
      b.addEventListener('click', action);
      return b;
    }
    draw(focus) {
      this.signup?.destroy();
      const ui = this.config.ui;
      const node = this.nodes.get(this.id);
      this.host.dataset.quizStage = node.nodeType === 'result' ? 'result' : this.id === this.config.start_question ? 'start' : 'question';
      const fragment = document.createDocumentFragment();
      const nav = el('div', 'tq-nav');
      const back = this.button(ui.back, 'tq-text-button', () => this.back());
      back.disabled = this.history.length === 0;
      nav.append(back, this.button(ui.restart, 'tq-text-button', () => this.restart()));
      fragment.append(nav);
      const stage = el('section', 'tq-stage');
      stage.dataset.nodeId = this.id;
      stage.setAttribute('aria-labelledby', this.root.id + '-heading');
      const label = node.nodeType === 'question' ? ui.question + ' ' + (this.history.length + 1) : ui.result;
      stage.append(el('p', 'tq-eyebrow', label));
      const heading = el('h2', '', node.nodeType === 'question' ? node.prompt : node.title);
      heading.id = this.root.id + '-heading';
      heading.tabIndex = -1;
      stage.append(heading);
      if (node.nodeType === 'question') {
        if (node.description) stage.append(el('p', 'tq-question-detail', node.description));
        const grid = el('div', 'tq-choices');
        node.choices.forEach((answer, i) => {
          const button = this.button('', 'tq-choice', () => this.choose(answer.value));
          button.dataset.value = answer.value;
          const art = el('span', 'tq-art tq-art-' + (i % 4));
          art.setAttribute('aria-hidden', 'true');
          const imageUrl = this.config.images?.[answer.image_id];
          if (imageUrl) {
            const picture = el('picture');
            const desktopUrl = this.config.images?.[answer.desktop_image_id];
            if (desktopUrl) {
              const source = el('source');
              source.media = '(min-width: 761px)';
              source.srcset = desktopUrl;
              picture.append(source);
            }
            for (const axis of ['x', 'y']) {
              const position = answer['desktop_object_position_' + axis];
              if (typeof position === 'number' && Number.isFinite(position) && position >= 0 && position <= 100) {
                art.style.setProperty('--tq-desktop-position-' + axis, position + '%');
              }
            }
            const img = el('img', 'tq-choice-image');
            img.src = imageUrl;
            img.alt = '';
            img.width = 640;
            img.height = 640;
            img.decoding = 'async';
            picture.append(img);
            art.append(picture);
          } else {
            art.append(el('span', 'tq-art-shape'), el('span', 'tq-art-number', String(i + 1).padStart(2, '0')));
          }
          const copy = el('span', 'tq-choice-copy');
          copy.append(el('span', 'tq-choice-label', answer.label));
          if (answer.description) copy.append(el('span', 'tq-choice-detail', answer.description));
          button.append(art, copy, el('span', 'tq-arrow', '→'));
          grid.append(button);
        });
        stage.append(grid);
      } else {
        stage.append(el('p', 'tq-reason', node.reason));
        if (this.history.some(entry => entry.id === 'alternate_task')) stage.append(el('p', 'tq-fit', ui.alternate_result_note));
        const product = this.config.products[node.product_key];
        if (product) {
          const card = el('div', 'tq-product');
          const productInfo = el('div', 'tq-product-info');
          productInfo.append(el('p', 'tq-eyebrow', ui.brand), el('h3', '', product.title));
          if (this.host.dataset.showImages === 'true' && product.image) {
            const photo = el('img', 'tq-product-image');
            photo.src = product.image;
            photo.alt = '';
            photo.width = 480;
            photo.height = 480;
            photo.decoding = 'async';
            card.append(photo);
          }
          card.append(productInfo);
          if (product.available === false) card.append(el('p', 'tq-stock', ui.sold_out));
          const link = el('a', 'tq-primary', ui.shop);
          link.href = product.url;
          link.addEventListener('click', () => window.TekoFinderSignup?.activity(this.host, false));
          card.append(link);
          stage.append(card);
        }
        stage.append(el('p', 'tq-fit', node.fit_note));
        const signup = el('div', 'tq-result-signup');
        signup.dataset.quizSignup = '';
        stage.append(signup);
        const browseLinks = (ui.browse_links || []).filter(link => link.title && link.url && new URL(link.url, 'https://tekoclean.com').protocol === 'https:');
        if (browseLinks.length) {
          const browse = el('aside', 'tq-browse');
          browse.append(el('h3', '', ui.browse_title), el('p', '', ui.browse_detail));
          const links = el('div', 'tq-browse-links');
          browseLinks.forEach(item => {
            const link = el('a', 'tq-browse-link', item.title);
            link.href = item.url;
            link.addEventListener('click', () => window.TekoFinderSignup?.activity(this.host, false));
            links.append(link);
          });
          browse.append(links);
          stage.append(browse);
        }
        stage.append(this.button(ui.find_another || ui.restart, 'tq-text-button tq-find-another', () => this.restart()));
      }
      fragment.append(stage);
      this.root.replaceChildren(fragment);
      const signupMount = this.root.querySelector('[data-quiz-signup]');
      if (signupMount && window.TekoFinderSignup) {
        try { this.signup = new window.TekoFinderSignup.Signup(this, signupMount); } catch (_) { signupMount.replaceChildren(el('p', 'tq-signup-status', ui.signup_unavailable)); }
      }
      if (focus) {
        heading.focus({ preventScroll: true });
        if (this.host.getBoundingClientRect().top < 0) this.host.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
      const inspector = this.host.querySelector('[data-quiz-inspector]');
      if (inspector) inspector.textContent = JSON.stringify(this.snapshot(), null, 2);
      this.host.querySelector('[data-quiz-status]').textContent = label;
    }
  }
  class TekoProductQuiz extends HTMLElement {
    disconnectedCallback() { this.quiz?.signup?.destroy(); window.TekoFinderSignup?.activity(this, false); }
    connectedCallback() {
      if (this.quiz) { this.quiz.draw(false); return; }
      if (!this.querySelector('[data-quiz-definition]')) return;
      const root = this.querySelector('[data-teko-quiz]');
      const ui = JSON.parse(this.querySelector('[data-quiz-ui]').textContent);
      try { this.signupOptions = JSON.parse(this.querySelector('[data-quiz-signup-options]')?.textContent || '{}'); } catch (_) { this.signupOptions = {}; }
      try {
        const config = JSON.parse(this.querySelector('[data-quiz-definition]').textContent);
        const productList = JSON.parse(this.querySelector('[data-quiz-products]').textContent);
        const imageList = JSON.parse(this.querySelector('[data-quiz-images]').textContent);
        const products = new Map(productList.map(p => [String(p.id), p]));
        for (const [key, reference] of Object.entries(config.products)) {
          const product = products.get(String(reference.product_id));
          if (!product) throw Error('Missing linked product: ' + key);
          config.products[key] = product;
        }
        config.images = Object.fromEntries(imageList.filter(i => i.url && new URL(i.url, 'https://tekoclean.com').protocol === 'https:').map(i => [String(i.id), i.url]));
        config.ui = ui;
        this.quiz = new Quiz(root, config, this);
      } catch (error) {
        const message = el('p', 'tq-error', ui.load_error);
        message.setAttribute('role', 'alert');
        root.replaceChildren(message);
        const inspector = this.querySelector('[data-quiz-inspector]');
        if (inspector) inspector.textContent = error.message;
      }
    }
  }
  if (!customElements.get('teko-product-quiz')) customElements.define('teko-product-quiz', TekoProductQuiz);
})();

  } catch(e) { console.error(e); }
})();
})();
